<!-- [フッター] -->
<footer class="l-footer">
  <div class="l-wrap">
    <div class="l-wrap__inner">
      <div class="l-footer__inner">
        <div class="l-footer__menu-area">
          <div class="l-footer-menu">
            <ul class="l-footer-menu__list">
              <li class="l-footer-menu__item" [innerHTML]="'label.privacyPolicy' | staticMsg"></li>
              <li
                *ngIf="isDisplayCookieSettingsLink"
                class="l-footer-menu__item"
                [innerHTML]="'label.cookieSettings' | staticMsg"
                (click)="openModal()"
                style="cursor: pointer"
              ></li>
              <li
                *ngIf="isDisplayCaliforniaPrivacyRightsAcLink"
                class="l-footer-menu__item"
                [innerHTML]="'label.californiaPrivacyRightsAct' | staticMsg"
              ></li>
              <li
                *ngIf="isDisplayExternalTransmissionOfUserInfoLink"
                class="l-footer-menu__item"
                [innerHTML]="'label.externalTransmissionOfUserInfo' | staticMsg"
              ></li>
              <li class="l-footer-menu__item" [innerHTML]="'label.termsOfUse' | staticMsg"></li>
              <li
                *ngIf="isDisplayImprintLink"
                class="l-footer-menu__item"
                [innerHTML]="'label.imprint' | staticMsg"
              ></li>
              <li class="l-footer-menu__item" [innerHTML]="'label.recommendedEnvironment' | staticMsg"></li>
              <li class="l-footer-menu__item" [innerHTML]="'label.siteMap' | staticMsg"></li>
              <li class="l-footer-menu__item" [innerHTML]="'label.conditionsOfCarriage' | staticMsg"></li>
              <li class="l-footer-menu__item" [innerHTML]="'label.description.webAccessibility' | staticMsg"></li>
            </ul>
          </div>
        </div>
        <div class="l-footer-desc">
          <ul class="l-footer-desc__list">
            <li class="l-footer-desc__item" [innerHTML]="'message.externalLink.notes' | staticMsg"></li>
          </ul>
        </div>
        <div class="l-footer-bottom">
          <div class="l-footer-bottom__logos-area">
            <div class="l-footer-logos">
              <div class="l-footer-logos__item l-footer-logos__item--ana l-footer-logos__item__ana__fix">
                <a
                  id="l-footer-analogo"
                  [href]="_headerService.getTopUrl()"
                  [innerHTML]="_headerService.getAnaLogo() | staticMsg"
                  aswThrottleClick
                  (throttleClick$)="onClickAnaLogo($event)"
                ></a>
              </div>
              <div
                class="l-footer-logos__item l-footer-logos__item--star"
                [innerHTML]="'alt.starAllianceMember' | staticMsg"
              ></div>
            </div>
          </div>
          <div class="l-footer-bottom__copyright-area">
            <div class="l-footer-copyright" [innerHTML]="'message.copyrightAna' | staticMsg"></div>
          </div>
        </div>
        <div class="l-footer-page-top" (click)="onClickPageTop()">
          <a id="footer-top-scroll-button" class="l-footer-page-top__button" href="#" onclick="return false;"
            ><span class="l-footer-page-top__text" [innerHTML]="'label.pageTop' | staticMsg"></span
          ></a>
        </div>
      </div>
    </div>
  </div>
</footer>
<!-- [フッター] -->
